"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalManager = void 0;
const bootstrap_1 = require("bootstrap");
/**
 * Gestor de modales de Bootstrap
 */
class ModalManager {
    constructor() {
        this.modals = new Map();
    }
    show(modalId, options) {
        const element = document.getElementById(modalId);
        if (!element) {
            console.error(`Modal con ID '${modalId}' no encontrado`);
            return;
        }
        let modal = this.modals.get(modalId);
        if (!modal) {
            modal = new bootstrap_1.Modal(element, options);
            this.modals.set(modalId, modal);
        }
        modal.show();
    }
    hide(modalId) {
        const modal = this.modals.get(modalId);
        if (modal) {
            modal.hide();
        }
        else {
            const element = document.getElementById(modalId);
            if (element) {
                const existingModal = bootstrap_1.Modal.getInstance(element);
                if (existingModal) {
                    existingModal.hide();
                }
            }
        }
    }
    showSpinner() {
        this.show("spinnerModal", {
            backdrop: "static",
            keyboard: false
        });
    }
    hideSpinner() {
        this.hide("spinnerModal");
    }
    showSuccess() {
        this.show("successModal", {
            backdrop: "static",
            keyboard: false
        });
    }
    dispose() {
        this.modals.forEach((modal) => {
            modal.dispose();
        });
        this.modals.clear();
    }
}
exports.ModalManager = ModalManager;
